import { IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ILayoutTitleDetails } from '../types';

export const LayoutTitle: React.FC<ILayoutTitleDetails> = ({ breadcrumbs, currentPath, title = '', showTitle = false }) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Stack spacing={2}>
            {showTitle &&
                <Typography variant="h6" sx={{ fontFamily: "htrts_semibold", pl: 0.5 }}>{title}</Typography>
            }
            <Stack
                spacing={1}
                direction={"row"}
                sx={{
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexWrap: "wrap"
                }}
            >
                {breadcrumbs.map((his, key) => {
                    return <React.Fragment key={key}>
                        <IconButton id={`${his.label}-${key}`} size="small" disableRipple>
                            <Typography component="a" href={his.path || location.pathname} variant="body2"
                                onClick={(e) => {
                                    if (!his.path) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    } else {
                                        navigate(his.path ?? "")
                                    }
                                }}
                                sx={{
                                    color: "rgba(0, 0, 0, 0.54)",
                                    textDecoration: "none",
                                    fontFamily: "htrts_medium",
                                    '&:hover': {
                                        color: (theme) => theme.palette.primary.main,
                                        cursor: "pointer",
                                        textDecoration: "underline"
                                    }
                                }}
                            >{his.label}</Typography>
                        </IconButton>
                        <span>{" >"}</span>
                    </React.Fragment>
                })}
                <Typography variant="body2" color={"primary"} sx={{ fontFamily: "htrts_regular" }}>{currentPath}</Typography>
            </Stack>
        </Stack>
    )
}
